import '@babel/polyfill'
import $ from 'jquery'
import 'select2'
import 'select2/dist/css/select2.css'

export default () => {
    $(document).ready(function() {
        $('.js-hero-select').select2({
            minimumResultsForSearch: Infinity
        })
    })

    const urlVars = getUrlVars()
    const forfilter = document.querySelector("#for-filter")
    const forChecks = document.querySelectorAll('input[type="checkbox"]')
    const categoryfilter = document.querySelector("#category-filter")
    const trainings = document.querySelectorAll("[data-for][data-category]")

    var forcat = []
    var cat = ""

    const initForChecks = function() {
        forChecks.forEach(check => {
            if(forcat.includes(check.name)){
                check.checked = true
            } else {
                check.checked = false
            }
        })
    }
    const checkAll = function(checkBoxes = true) {
        forChecks.forEach(check => {
            if(checkBoxes)
                check.checked = true
            forcat.push(check.name)
        })
    }

    if(urlVars.for){
        forcat = urlVars.for.split("-")
        initForChecks()
        
    }else{
        checkAll()
    }
    if(urlVars.category){
        cat = urlVars.category
        $('#category-filter').val(cat)
    }

    if(forfilter && !urlVars.for && !urlVars.category){
        forcat = forfilter.value
        cat = categoryfilter.value
    }

    forChecks.forEach(check => {
        check.addEventListener('change', (event) => {
            addFors()
            filterTrainings()
        })
    })

    const filterTrainings = function() {
        trainings.forEach(training => {
            if(forcat.some(function(v) { return training.dataset.for.indexOf(v) >= 0; }) &&/*training.dataset.for == forcat && */training.dataset.category.includes(cat)){
                training.classList.remove("hidden")
            } else{
                if (!training.classList.contains("hidden")){
                    training.classList.add("hidden")
                }
            } 
            window.history.pushState("", "", "https://" + window.location.hostname + window.location.pathname + "?for="+forcat.join('-')+"&category="+cat)
        });
    }

    const addFors = function() {
        forcat = []
        forChecks.forEach(check => {
            if(check.checked){
                forcat.push(check.name)
            }
        })
        if(forcat.length < 1){
            checkAll(false)
        }
    }

    filterTrainings()

    /*$('#for-filter').change(function(){
        forcat = $('#for-filter').select2('data')[0].id
        //filterTrainings()
    })*/
    $('#category-filter').change(function(){
        cat = $('#category-filter').select2('data')[0].id
        filterTrainings()
    })
}


function getUrlVars() {
	var vars = {}
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
		vars[key] = value
	})
	return vars
}